var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { UpdateMapObject } from "Server/Commands/UpdateMapObject";
import { PanelHeader } from "UI/Write/MapUI/Panel";
import { Column, Pre, RowLR, TextInput, Spinner, Button } from "react-vcomponents";
import { BaseComponent, BaseComponentPlus } from "react-vextensions";
import { ShapeType, ShapeCompUI, ShapeComp } from "Store/firebase/mapObjects/Components/@ShapeComp";
import { LabelCompUI, LabelComp } from "Store/firebase/mapObjects/Components/@LabelComp";
import { Vector2i, VRect, ModifyString } from "js-vextensions";
import { DraggableLabel, Observer } from "vwebapp-framework";
import { runInAction } from "mobx";
import { store } from "Store";
import { GetSelectedMapObject } from "Store/firebase/mapObjects";
import { CompUIWrapper } from "./ObjectPanel/General";
import { currentMapTool } from "../MapScene";
export const CompUI_splitAt = 80;
export const CompUI_width = "100%";
let ObjectPanel = class ObjectPanel extends BaseComponentPlus({}, {}) {
    render() {
        const obj = GetSelectedMapObject();
        //if (obj == null) return <Column className="ObjectPanel">Loading...</Column>;
        const sharedProps = this.props.Extended({ obj });
        return (React.createElement(Column, { className: "ObjectPanel" },
            React.createElement(PanelHeader, { text: "Object" }),
            obj
                && React.createElement(Column, null,
                    React.createElement(RowLR, { mt: 5, splitAt: CompUI_splitAt, style: { CompUI_width } },
                        React.createElement(Pre, null, "Name: "),
                        React.createElement(TextInput, { required: true, delayChangeTillDefocus: true, style: { width: "100%" }, value: obj.name, onChange: val => {
                                new UpdateMapObject({ id: obj._key, updates: { name: val } }).Run();
                            } })),
                    React.createElement(TransformCompUI, Object.assign({}, sharedProps)),
                    obj.shape && React.createElement(ShapeCompUI, Object.assign({}, sharedProps)),
                    !obj.shape && React.createElement(CompAddStub, { obj: obj, compProp: "shape", initializer: () => new ShapeComp({ type: ShapeType.Rectangle, rect: new VRect(new Vector2i(), new Vector2i()) }) }),
                    obj.label && React.createElement(LabelCompUI, Object.assign({}, sharedProps)),
                    !obj.label && React.createElement(CompAddStub, { obj: obj, compProp: "label", initializer: () => new LabelComp({ text: "Label1", offset: new Vector2i() }) }))));
    }
};
ObjectPanel = __decorate([
    Observer
], ObjectPanel);
export { ObjectPanel };
class CompAddStub extends BaseComponent {
    render() {
        const { obj, compProp, initializer } = this.props;
        return (React.createElement(Button, { text: `Add ${ModifyString(compProp, m => [m.startLower_to_upper, m.lowerUpper_to_lowerSpaceLower])}`, onClick: () => {
                new UpdateMapObject({ id: obj._key, updates: { [compProp]: initializer() } }).Run();
            } }));
    }
}
export class TransformCompUI extends BaseComponent {
    render() {
        const { obj, mapUI } = this.props;
        const dragSpeed = mapUI.mapScene ? mapUI.mapScene.PixelLengthInMeters() : 0; // mapUI.mapScene can be null at end of drag
        return (React.createElement(CompUIWrapper, { obj: obj, compProp: "transform" },
            React.createElement(RowLR, { mt: 5, splitAt: CompUI_splitAt, style: { CompUI_width } },
                React.createElement(DraggableLabel, { style: { width: CompUI_splitAt }, onDragStart: () => {
                        runInAction("TransformCompUI.transformX.onDragStart", () => {
                            store.main.write.tools.moveObject.targetObject = obj._key;
                            store.main.write.selectedTool = "MoveObject";
                        });
                    }, onDrag: (dragDelta, dragTotal, final) => {
                        const newPos = obj.position.As(Vector2i).NewX(x => x + (dragTotal.x * dragSpeed));
                        if (final) {
                            const updates = { position: newPos };
                            new UpdateMapObject({ id: obj._key, updates }).Run();
                            runInAction("TransformCompUI.transformX.onDrag", () => {
                                store.main.write.selectedTool = null;
                            });
                        }
                        else {
                            currentMapTool.UpdateNewPos(newPos);
                        }
                    } }, "X:"),
                React.createElement(Spinner, { min: Number.MIN_SAFE_INTEGER, step: "any", style: { minWidth: 0 }, value: obj.position.x, onChange: val => {
                        const updates = { position: obj.position.As(Vector2i).NewX(val) };
                        new UpdateMapObject({ id: obj._key, updates }).Run();
                    } })),
            React.createElement(RowLR, { mt: 5, splitAt: CompUI_splitAt, style: { CompUI_width } },
                React.createElement(DraggableLabel, { style: { width: CompUI_splitAt }, onDragStart: () => {
                        runInAction("TransformCompUI.transformY.onDragStart", () => {
                            store.main.write.tools.moveObject.targetObject = obj._key;
                            store.main.write.selectedTool = "MoveObject";
                        });
                    }, onDrag: (dragDelta, dragTotal, final) => {
                        const newPos = obj.position.As(Vector2i).NewY(y => y + (dragTotal.x * dragSpeed));
                        if (final) {
                            const updates = { position: newPos };
                            new UpdateMapObject({ id: obj._key, updates }).Run();
                            runInAction("TransformCompUI.transformY.onDrag", () => {
                                store.main.write.selectedTool = null;
                            });
                        }
                        else {
                            currentMapTool.UpdateNewPos(newPos);
                        }
                    } }, "Y:"),
                React.createElement(Spinner, { min: Number.MIN_SAFE_INTEGER, step: "any", style: { minWidth: 0 }, value: obj.position.y, onChange: val => {
                        const updates = { position: obj.position.As(Vector2i).NewY(val) };
                        new UpdateMapObject({ id: obj._key, updates }).Run();
                    } }))));
    }
}
